//Margin conventions
var margin = {top: 20, right: 15, bottom: 25, left: 40};

var widther = d3.select(".gia-chart").node().clientWidth;

var width = widther - margin.left - margin.right,
    height = 350 - margin.top - margin.bottom;

//Parses date for correct time format
var parseDate = d3.time.format("%Y").parse;  

//Appends the svg to the chart-container div
var svg = d3.select(".gia-chart").append("svg")
	.attr("width", width + margin.left + margin.right)
	.attr("height", height + margin.top + margin.bottom)
	.append("g")
	.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

//Creates the xScale 
var xScale = d3.time.scale()
  .range([0, width]);

//Creates the yScale
var yScale = d3.scale.linear()
  .range([height, 0]);

//Color scale
var color = d3.scale.ordinal()
  .domain(["millennial", "boomer"])
  .range(["#f46980", "#dcdcdc"]);  

//Defines the y axis styles
var yAxis = d3.svg.axis()
	.scale(yScale)
  .tickSize(-width)
  .tickPadding(8)
  .tickFormat(function(d) { return d + "%"; })
	.orient("left");

//line function convention (feeds an array)
var stack = d3.layout.stack()
  .offset("zero")
  .values(function(d) { return d.values;})
  .x(function(d) { return d.year;})
  .y(function(d) { return d.percent;});

var nest = d3.nest()
  .key(function(d) { return d.gen;});

var area = d3.svg.area()
    .interpolate("cardinal")
    .x(function(d) { return xScale(d.year); })
    .y0(function(d) { return yScale(d.y0); })
    .y1(function(d) { return yScale(d.y0 + d.y); });     

//Loads the data
d3.csv("data/voterShare.csv", ready);

function ready(err, data) {

	if (err) throw "error loading data";

	//FORMAT data
	data.forEach(function(d) {
		d.percent = +d.percent;
    d.year = parseDate(d.year);
	});
	
	//Organizes the data	
  var maxY = d3.max(data, function(d) { return d.percent; });

  var layers = stack(nest.entries(data));

  //Array of all years
  var yearValues = data.map(function(d){return d.year;});  

  //Defines the y axis styles
  var xAxis = d3.svg.axis()
    .scale(xScale)
    .tickPadding(8)
    .orient("bottom")
    .tickValues(yearValues)
    .tickFormat(d3.time.format("%Y")); 

  //Defines the xScale max
  xScale.domain(d3.extent(data, function(d) { return d.year; }));

  //Defines the yScale max
  yScale.domain([0, d3.max(data, function(d) { return d.y0 + d.y; })]);

	//Appends the x axis		
	var xAxisGroup = svg.append("g")
		.attr("class", "x axis")
		.attr("transform", "translate(0," + height + ")")
		.call(xAxis);  

  //Appends the y axis
  var yAxisGroup = svg.append("g")
    .attr("class", "y axis")
    .call(yAxis)
    .selectAll("g")
    .classed("g-baseline", function(d) {return d == 0}); 

  var xTicks = d3.selectAll(".x.axis text") 
    .attr("class", function(d, i) {
      return 'xText'+i;
    });    

  //Binds the data to the line
  var drawArea = svg.selectAll(".gia-layer")
    .data(layers)
    .enter()
    .append("path")
    .attr("class", "gia-layer")
    .attr("d", function(d) { return area(d.values);})
    .style("fill", function(d) { return color(d.key);});   

  //Append labels  
  var boomerLabel = svg.append("text")
      .text("Boomer & prior generations")
      .attr("class", "boomer-label")
      .attr("x", width/3.2)
      .attr("y", height/2.75);   

  var millLabel= svg.append("text")
      .text("Younger generations")
      .attr("class", "mill-label")
      .attr("x", width/2)
      .attr("y", height/1.15);       	

//RESPONSIVENESS
  d3.select(window).on("resize", resized);

  function resized() {

    //new margin
    var newMargin = {top: 20, right: 15, bottom: 25, left: 40};

    var newWidther = d3.select(".gia-chart").node().clientWidth;

    var newWidth = newWidther - newMargin.left - newMargin.right;

    //Change the width of the svg
    d3.select("svg")
      .attr("width", newWidth + newMargin.left + newMargin.right);

    //Change the xScale
    xScale
      .range([0, newWidth]);

    //Change the area  
    stack
      .x(function(d) { return d.year;})
      .y(function(d) { return d.percent;});

    area
      .x(function(d) { return xScale(d.year); });  

    drawArea
      .attr("d", function(d) { return area(d.values);})
      .style("fill", function(d) { return color(d.key);});  
    
    //Updates xAxis
    d3.selectAll(".x.axis")
         .call(xAxis);     

    //Updates ticks
    xAxis
      .scale(xScale)
      .tickValues(yearValues);

    //Updates yAxis
    d3.selectAll(".y.axis")
      .call(yAxis); 

    yAxis
      .tickSize(-newWidth);

   //Updates labels   
   boomerLabel
      .attr("x", newWidth/3.2);

    millLabel 
       .attr("x", newWidth/2);
      
  };

}